import { API_NAME, REDUX_STORE } from '@funnels/constants';
import { PostProductSelectActionTypes, PostProductSelectReducerState, SharedActionTypes } from '@funnels/types';

const initialState: PostProductSelectReducerState = {
  data: [],
  error: null,
  loading: 0,
};

export default function postProductSelectReducer(
  state: PostProductSelectReducerState = initialState,
  action: PostProductSelectActionTypes | SharedActionTypes
): PostProductSelectReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: [],
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.CLEAR_POST_PRODUCT_SELECT_ERROR:
      return {
        ...state,
        error: null,
      };

    case REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.FETCH_POST_PRODUCT_SELECT:
      return {
        ...state,
        data: [],
        loading: state.loading + 1,
      };
    case REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.FETCH_POST_PRODUCT_SELECT_SUCCESS:
      return {
        ...state,
        data: action.contract,
        loading: state.loading - 1,
      };

    case REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.FETCH_POST_PRODUCT_SELECT_FAIL:
      return {
        ...state,
        error: {
          name: API_NAME.POST_PRODUCT_SELECT,
          message: action.message,
        },
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
